import CnsValidate from './rules/cns'
const validator = {
  getMessage () { // will be added to default English messages.
    return 'Invalid CNS'
  },
  validate (value) {
    return CnsValidate(value)
  }
}
export default validator